import React, { FC, memo } from 'react';
import { Field } from 'formik';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import CollapsibleSection from '../../../../components/CollapsibleSection/CollapsibleSection';
import Spinner from '../../../../components/Spinner';
import RenderInput from '../../../../components/RenderInput';
import AmountCurrencyRateBox from '../subForms/AmountCurrencyRateBox';

type FormProps = {
    creditOrDebit: 'Credit' | 'Debit';
    totalBalance?: number;
    documentGenerationData?: any;
};

// Form component:
const CreditDebitNoteForm: FC<FormProps> = memo((props) => {
    // @ts-ignore (ignoring type definition of formProps in React children)
    const { formProps, creditOrDebit, totalBalance, documentGenerationData } = props;
    const { isSubmitting, values } = formProps;
    const amountExceedsBalance = totalBalance && values.amount && Number(values.amount) > totalBalance;

    return (
        <CollapsibleSection label={`${creditOrDebit} Note Details`} card>
            <Stack spacing={2}>
                <Field
                    component={RenderInput}
                    label="For"
                    name="for"
                    disabled={isSubmitting}
                    fullWidth
                    margin="none"
                />
                <Field
                    component={RenderInput}
                    label="Beneficiary"
                    name="beneficiary"
                    disabled
                    fullWidth
                    margin="none"
                />
                <Field
                    component={RenderInput}
                    name="dueDate"
                    type="date"
                    label="Value Date"
                    placeholder="__/__/____"
                    mask="__/__/____"
                    format="dd/MM/yyyy"
                    autoOk
                    disabled={isSubmitting}
                    fullWidth
                    margin="none"
                />
                <AmountCurrencyRateBox
                    documentGenerationData={documentGenerationData}
                    disabled={isSubmitting}
                />
                {amountExceedsBalance && (
                    <Typography variant="caption" color="warning.main">
                        Amount exceeds travel file balance ({totalBalance})
                    </Typography>
                )}
                <Field
                    component={RenderInput}
                    label="Remark"
                    name="remark"
                    multiline
                    rows={2}
                    disabled={isSubmitting}
                    fullWidth
                    margin="none"
                />
            </Stack>
            {isSubmitting && <Spinner />}
        </CollapsibleSection>
    );
});

export default memo(CreditDebitNoteForm);
